import {VFC, memo, useCallback} from 'react';
import {stringify} from 'query-string';

import KeepAlive from 'react-activation';
import {useNavigationType} from 'react-router-dom';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import {useSearchParams} from '@/hooks/router';
import Skeleton from './Skeleton';
import {StoreProvider} from './Store';
interface Props {
    path?: string;
    children: JSX.Element | JSX.Element[];
}

const routeTimesMap = new Map<string, number>();
let preName = 0;

const CustomRouteWrap: VFC<Props> = props => {
    const {
        path,
        children,
    } = props;
    const NAVIGATE_TYPE = useNavigationType();
    // 将查询参数作为keep-alive的唯一id;
    const query = useSearchParams();
    const queryString = stringify(query);

    const name = queryString ? path + '?' + queryString : path;

    const getRid = useCallback(
        name => {
            if (NAVIGATE_TYPE === 'PUSH' && preName !== name) {
                preName = name;
                const rid = Date.now();
                routeTimesMap.set(name || '', rid);
                return rid;
            } else {
                preName = name;
                return routeTimesMap.get(name || '');
            }
        },
        [NAVIGATE_TYPE]
    );

    return (
        <KeepAlive
            key={path}
            id={`${getRid(name)}`}
            name={name}
        >
            <ErrorBoundary key={path}>
                <StoreProvider>
                    <Skeleton path={path} />
                    {children}
                </StoreProvider>
            </ErrorBoundary>
        </KeepAlive>
    );
};

export default memo(CustomRouteWrap);
